import React from 'react';
import styled from 'styled-components';

import Section from '../components/section';
import { Title } from '../components/text';
import Toolkit from '../components/toolkit';
import { stylesFor } from '../styles/utilities';

const ToolkitList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  a {
    margin-bottom: 16px;
  }

  ${stylesFor.xLargeUp`
    display: none;
  `};
`;

const ToolkitGallery = styled.div`
  display: flex;
  margin-top: 80px;

  div:not(:last-child) {
    margin-right: 32px;
  }

  ${stylesFor.underXLarge`
    display: none;
  `};
`;

const toolkits = [  
  {
    icon: 'images/iconSharePointToolkit.svg',
    name: 'SharePoint Web UI toolkit',
    description:
      'The UI kit provides templates, components, and detailed guidance for designing a SharePoint site including the header and footer, sections, and web parts.',
    linkText: 'Access UI Kit',
    linkTarget: 'https://www.figma.com/community/file/1260359051156407926',
  },
  {
    icon: 'images/iconSharePointToolkit.svg',
    name: 'SharePoint design language toolkit',
    description:
      'The SharePoint design toolkit provides everything you need to design your web parts.',
    linkText: 'Download',
    linkTarget: 'https://developer.microsoft.com/en-us/fluentui#/resources',
  },
  {
    icon: 'images/iconFabricToolkit.svg',
    name: 'Fluent toolkits',
    description:
      'The Fluent design toolkits are built with Figma and Sketch and provide styles, controls, and layout templates that enable you to create beautiful and coherent Microsoft experiences.',
    linkText: 'Download',
    linkTarget: 'https://developer.microsoft.com/en-us/fluentui#/resources',
  },
  {
    icon: 'images/iconTextSize.svg',
    name: 'Fonts',
    description:
      'Toolkits leverage Segoe UI and MDL2 icon fonts. To get the most out of the toolkits download the fonts, you can replace with a custom font if needed for your specific project.',
    linkText: 'Download',
    linkTarget: 'https://developer.microsoft.com/en-us/fluentui#/resources',
  },
  {
    icon: 'images/iconPalette.svg',
    name: 'Fluent UI Theme Designer',
    description: 'This tool helps you easily create a theme for your sites.',
    linkText: 'Give it a try',
    linkTarget:
      'https://fluentuipr.z22.web.core.windows.net/heads/master/theming-designer/index.html',
  },
  {
    icon: 'images/iconAccessibility.svg',
    name: 'Accessibility',
    description:
      'Learn more about accessibility and designing for inclusivity with these great resources.',
    linkText: 'Learn more',
    linkTarget: 'https://www.microsoft.com/en-us/accessibility',
  },
];

export default () => {
  return (
    <Section background="linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1)), url('images/grid.svg') top left/80px 80px">
      <Title>Toolkits &amp; resources</Title>
      <ToolkitList>
        {toolkits.map(toolkit => <Toolkit {...toolkit} key={toolkit.name} />)}
      </ToolkitList>
      <ToolkitGallery>
        {toolkits.map(toolkit => (
          <Toolkit {...toolkit} key={toolkit.name} isLarge={true} />
        ))}
      </ToolkitGallery>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/sections/toolkits.js